/**
 * @generated SignedSource<<974ac2acbda9127063ccf1a88a0bb2ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tagId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "tagId",
        "variableName": "tagId"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "deleteTag",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteTagMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteTagMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "41f1c120c4c27dde7e61b467d8a920b7",
    "id": null,
    "metadata": {},
    "name": "DeleteTagMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteTagMutation(\n  $tagId: ID!\n) {\n  deleteTag(tagId: $tagId) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "ed3d8c126f9c90069da129acc85fbc2b";

export default node;
